<ion-header>
  <ion-toolbar>
    <ion-title></ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>


<ion-content>
  <ul class="result-list" *ngIf="activeReason?.result?.failed_rules && activeReason.result.failed_rules.length"
    style="padding-top: 10px;">
    <li *ngFor="let rule of activeReason.result.failed_rules" style="padding: 4px 0;">{{ rule.message }}</li>
  </ul>
  <p *ngIf="!activeReason?.result?.failed_rules || !activeReason.result.failed_rules.length"
    style="margin-top: 10px; color:#666">No se encontraron
    detalles.</p>
</ion-content>